import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ExternalCallbackService {

    constructor(private api: ApiService) { }

    resendLeads(pkExtCallback: number, data: Object) : Observable<any> {
        return this.api.get('vna/external-callback-leads/' + pkExtCallback + '/resend', data);
    }

    countLeadsResend(pkExtCallback: number, data: Object): Observable<any> {
        return this.api.get('vna/external-callback-leads/' + pkExtCallback + '/count', data);
    }

    saveFilters(pk: number, data: Object): Observable<any> {
        return this.api.customPatch('vna/external-callback/' + pk + '/filters', data);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/services/external-callback.service.ts